/*
 * @Description: 审核进度模块
 * @Author: Harry
 * @Date: 2020-12-28 14:31:09
 * @LastEditTime: 2020-12-28 15:19:37
 * @LastEditors: Harry
 */
import i18n from "@/locales";

export default [
  {
    //审核进度
    path: "/check-progress",
    name: "check-progress",
    component: () => import("@/views/create-account/CheckProgress.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("check_progress.nav_title")
    }
  }
];
